import React from "react";
import {render} from "react-dom";
import {Provider} from "react-redux";
import {OidcProvider} from "redux-oidc";

import {userManager} from "./Utilities";
import {store} from "./Redux";
import {App} from "./App";
import "./web.config";
import * as Sentry from "@sentry/react";
import {Integrations} from "@sentry/tracing";

import "bootstrap/dist/css/bootstrap-reboot.min.css";
import "bootstrap/dist/css/bootstrap-grid.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import "./LESS/Helpers/typography.less";

import "./LESS/main.less";
import "./LESS/print.less";

let dsn = "https://65247992a6d74f85b390a8b6419b40e9@o966103.ingest.sentry.io/4504909126959104";

if (process.env.REACT_APP_CLIENT_ID === 'onboarding.prod') {
    dsn = "https://65247992a6d74f85b390a8b6419b40e9@o966103.ingest.sentry.io/4504909126959104";
}

if (process.env.NODE_ENV !== "development") {
    Sentry.init({
        dsn: dsn,
        integrations: [new Integrations.BrowserTracing()],
        
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0
    });
    console.log('sentry has been initialized');
}
Sentry.captureMessage("Something went wrong");
// The above configuration captures both error and performance data. To reduce the volume of performance data captured, change tracesSampleRate to a value between 0 and 1.

render(
    <OidcProvider store={store} userManager={userManager}>
        <Provider store={store}>
            <App/>
        </Provider>
    </OidcProvider>,
    document.querySelector("#root")
);
